











































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import MenuPO from "@/store/entities/basedata/menupo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
  components: { TreeSelect },
})
export default class EditMenu extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  menupo: MenuPO = new MenuPO();
  loading: boolean = false;
  created() {
    this.itemtree();
  }
  create() {
    //console.log(this.list);
  }
  save() {
    (this.$refs.areaForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        await this.$store
          .dispatch({
            type: "menu/update",
            data: this.menupo,
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.areaForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemtree() {
    await this.$store
      .dispatch("menu/getselectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.menupo = Util.extend(true, {}, this.$store.state.menu.editItems);
    }
  }
  areaRule = {
    tagName: [
      {
        required: true,
        message: this.L("TagCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    parentId: [
      {
        type: "number",
        required: true,
        message: this.L("FirstNodeCanNotEmpty"),
        trigger: "blur",
      },
    ],
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ]
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
